export * from './src/rich-text-editor.module';
export * from './src/rich-text-editor.component';
